var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaMaskLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69231 24.7821L12.3327 25.748V24.4849L12.6299 24.1877H14.7101V25.6736V26.7137H12.4813L9.73241 25.525L8.69231 24.7821Z",
    fill: "#CDBDB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5791 24.7821L17.0131 25.748V24.4849L16.7159 24.1877H14.6357V25.6736V26.7137H16.8645L19.6132 25.525L20.5791 24.7821Z",
    fill: "#CDBDB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6299 22.0333L12.3327 24.4849L12.7041 24.1877H16.5673L17.0131 24.4849L16.7159 22.0333L16.1216 21.6617L13.1499 21.7361L12.6299 22.0333Z",
    fill: "#222A2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6239 5.46594L12.4069 9.62632L13.2242 21.7361H16.1215L17.0131 9.62632L18.6475 5.46594H10.6239Z",
    fill: "#F89C35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82328 14.604L0.743088 20.6216L5.94356 20.3245H9.28665V17.7243L9.13807 12.3752L8.39514 12.9696L2.82328 14.604Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7607 15.2726L12.8527 15.4212L12.1841 18.5415L9.28664 17.7985L6.7607 15.2726Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7607 15.3469L9.28664 17.7243V20.1016L6.7607 15.3469Z",
    fill: "#EA8D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28664 17.7986L12.2583 18.5415L13.2242 21.7362L12.5555 22.1075L9.28664 20.1759V17.7986Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28665 20.1759L8.69231 24.782L12.6299 22.0333L9.28665 20.1759Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8527 15.4211L13.2242 21.7361L12.1098 18.5043L12.8527 15.4211Z",
    fill: "#EA8E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86919 20.2503L9.28665 20.1759L8.69231 24.782L5.86919 20.2503Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.37752 26.788L8.69231 24.782L5.8692 20.2502L0.743088 20.6216L2.37752 26.788Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4069 9.62634L9.21241 12.3009L6.7607 15.2726L12.8527 15.4955L12.4069 9.62634Z",
    fill: "#E8821E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69231 24.782L12.6299 22.0332L12.3327 24.4106V25.7478L9.65818 25.2277L8.69231 24.782Z",
    fill: "#DFCEC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5791 24.782L16.7159 22.0332L17.0131 24.4106V25.7478L19.6876 25.2277L20.5791 24.782Z",
    fill: "#DFCEC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2183 16.7584L12.0355 18.4672L9.13807 17.7243L11.2183 16.7584Z",
    fill: "#222A2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30315 1.97437L12.4069 9.62642L10.6983 5.46604L2.30315 1.97437Z",
    fill: "#E88F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30315 1.97424L0.965889 6.06033L1.70881 10.5179L1.18877 10.815L1.93169 11.4837L1.33735 12.0037L2.15457 12.7466L1.63452 13.1924L2.8232 14.6783L8.39513 12.9695C11.1192 10.7903 12.4565 9.67589 12.4069 9.62637C12.3574 9.57684 8.98947 7.02613 2.30315 1.97424Z",
    fill: "#8E5A30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4481 14.604L28.5283 20.6216L23.3278 20.3245H19.9847V17.7243L20.1333 12.3752L20.8763 12.9696L26.4481 14.604Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5107 15.2726L16.4187 15.4212L17.0873 18.5415L19.9848 17.7985L22.5107 15.2726Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5107 15.3469L19.9848 17.7243V20.1016L22.5107 15.3469Z",
    fill: "#EA8D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9848 17.7986L17.0131 18.5415L16.0472 21.7362L16.7159 22.1075L19.9848 20.1759V17.7986Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9848 20.1759L20.5791 24.782L16.7159 22.1075L19.9848 20.1759Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4187 15.4211L16.0472 21.7361L17.1616 18.5043L16.4187 15.4211Z",
    fill: "#EA8E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4022 20.2503L19.9848 20.1759L20.5791 24.782L23.4022 20.2503Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8939 26.788L20.5791 24.782L23.4022 20.2502L28.5283 20.6216L26.8939 26.788Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8645 9.62634L20.059 12.3009L22.5107 15.2726L16.4187 15.4955L16.8645 9.62634Z",
    fill: "#E8821E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0531 16.7584L17.2359 18.4672L20.1333 17.7243L18.0531 16.7584Z",
    fill: "#222A2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9683 1.97437L16.8645 9.62642L18.5731 5.46604L26.9683 1.97437Z",
    fill: "#E88F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9682 1.97424L28.3055 6.06033L27.5626 10.5179L28.0826 10.815L27.3397 11.4837L27.934 12.0037L27.1168 12.7466L27.6369 13.1924L26.4482 14.6783L20.8763 12.9695C18.1522 10.7903 16.8149 9.67589 16.8645 9.62637C16.914 9.57684 20.2819 7.02613 26.9682 1.97424Z",
    fill: "#8E5A30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.668701 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMaskLogo);
export default __webpack_public_path__ + "static/media/metaMaskLogo.294758234b1a93bcd75b0524fcbf7b32.svg";
export { ForwardRef as ReactComponent };